<template>
  <!-- 权限检查已注释，所有用户可见 -->
  <!-- <div class="map-mode-switch" v-if="hasPermission"> -->
  <div class="map-mode-switch">
    <el-tooltip :content="tooltipText" placement="bottom">
      <el-button
        :type="isOffline ? 'warning' : 'primary'"
        size="small"
        :icon="isOffline ? 'el-icon-connection' : 'el-icon-map-location'"
        @click="toggleMapMode"
        class="map-mode-btn visualization-btn"
      >
        {{ buttonText }}
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
import {
  MAP_MODE,
  getCurrentMapMode,
  setMapMode,
  toggleMapMode as toggleMode
} from '@/config/mapConfig';
// 权限检查已注释，暂时不需要权限要求
// import { hasAdminAccess } from '@/utils/permissionUtils';

export default {
  name: 'MapModeSwitch',
  data() {
    return {
      currentMode: getCurrentMapMode()
      // 权限检查已注释
      // hasPermission: false
    };
  },
  computed: {
    isOffline() {
      return this.currentMode === MAP_MODE.OFFLINE;
    },
    buttonText() {
      return this.isOffline ? '切换为天地图' : '切换为电子海图';
    },
    tooltipText() {
      return this.isOffline
        ? '当前使用离线地图（卫星图+海图），点击切换回天地图'
        : '点击切换为电子海图（卫星图+海图+标注）';
    }
  },
  created() {
    // 权限检查已注释：仅管理员(ADMIN)或值班室(MONITOR)可见
    // this.checkPermission();
    // this.$root.$on('permissions-updated', this.checkPermission);
  },
  beforeDestroy() {
    // 权限检查已注释
    // this.$root.$off('permissions-updated', this.checkPermission);
  },
  methods: {
    /**
     * 检查用户权限（已注释）
     * 仅管理员(ADMIN)或值班室(MONITOR)可以切换地图模式
     */
    // checkPermission() {
    //   this.hasPermission = hasAdminAccess();
    //   console.log('MapModeSwitch权限检查:', this.hasPermission);
    // },

    /**
     * 切换地图模式
     */
    toggleMapMode() {
      const newMode = toggleMode();
      this.currentMode = newMode;

      // 发送全局事件通知所有地图组件
      this.$root.$emit('map-mode-changed', newMode);

      // 显示切换提示
      const modeName = newMode === MAP_MODE.OFFLINE ? '离线地图' : '天地图';
      // this.$message.success(`已切换为${modeName}模式`);

      console.log('地图模式已切换为:', newMode);
    }
  }
};
</script>

<style scoped>
.map-mode-switch {
  display: inline-flex;
  align-items: center;
}

.map-mode-btn {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.map-mode-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.map-mode-btn:active {
  transform: translateY(0);
}

/* 与顶栏其它快捷按钮保持一致（值同 Layout.vue .visualization-btn） */
.map-mode-btn.el-button--warning,
.map-mode-btn.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.map-mode-btn.el-button--warning:hover,
.map-mode-btn.el-button--primary:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
</style>